import React, { Component } from 'react'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
export default class DataTable extends Component {

    render() {

        return (
            <Table style={{ fontSize: '20px', fontWeight: 'bold' }}>
                <Thead>
                    <Tr >
                        <Th>#</Th>
                        <Th>Country</Th>
                        <Th>Cases</Th>
                        <Th>Today Cases</Th>
                        <Th>Active</Th>
                        <Th>Critical</Th>
                        <Th>Deaths</Th>
                        <Th>Today Deaths</Th>
                        <Th>Recovered</Th>
                        <Th>Today Recovered</Th>
                        <Th>Tests</Th>

                    </Tr>
                </Thead>
      
                <Tbody>
                    {this.props.data.filter((data)=>{
                      if ( this.props.searchedCountry == null ) return data 
                      else if (data.country.toLowerCase().includes(this.props.searchedCountry.toLowerCase()))
                      return data
                    }).map((data, index) =>

                        < Tr >
                            <Td  >{index + 1}</Td>
                            <Td>{data.country}</Td>
                            <Td>{data.cases}</Td>
                            <Td>{data.todayCases}</Td>
                            <Td>{data.active}</Td>
                            <Td>{data.critical}</Td>
                            <Td>{data.deaths}</Td>
                            <Td>{data.todayDeaths}</Td>
                            <Td>{data.recovered}</Td>
                            <Td>{data.todayRecovered}</Td>
                            <Td>{data.tests}</Td>

                        </Tr>)}


                </Tbody>
            </Table>
        )
    }
}
